import type { RouteRecord } from 'vite-react-ssg'

import Layout from './components/Layout'
import LandingPage from './pages/LandingPage'
import MdxPage from './pages/MdxPage'
import NotFound from './pages/NotFound'
import RedirectPage from './pages/RedirectPage'
import { flattenNav } from './nav'
import { redirects } from './redirects'

// One root layout route. The landing page is its index, every MDX page is a
// child keyed by its slug, and the splat catches unknown URLs. vite-react-ssg
// pre-renders each static path to its own HTML file and skips the splat (an
// unknown URL falls back to the SPA shell, which renders <NotFound/>).
export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <LandingPage /> },
      ...flattenNav().map((leaf) => ({
        path: leaf.slug.replace(/^\//, ''),
        element: <MdxPage leaf={leaf} />,
      })),
      // Moved pages keep a pre-rendered stub at the old path — see
      // redirects.ts for why these aren't real 301s.
      ...redirects.map((r) => ({
        path: r.from.replace(/^\//, ''),
        element: <RedirectPage to={r.to} />,
      })),
      { path: '*', element: <NotFound /> },
    ],
  },
]
